import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MyCheckoutComponent} from './my-checkout.component';
import {CompleteComponent} from './complete/complete.component';

@NgModule({
  declarations: [
    MyCheckoutComponent,
   CompleteComponent
  ],
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    SharedModule,
    MyCheckoutComponent,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class MyCheckoutModule {}
